<template>
<div >

	<Navbar></Navbar>
	<div class="main-content">
		<Loader :show="loading"></Loader>
		<div class="container" v-if="!loading">
			
			<div class="card mt-2">
				<div class="card-body">
		
					<div class="page-header">
						<ol class="breadcrumb">
							<li class="breadcrumb-item">GENERAL</li>
							<li class="breadcrumb-item active">Clientes</li>
						</ol>
						<div class="title">
							<h1>Clientes</h1>
						</div>
						<div class="cta">
							<b-dropdown text="Acciones" right  variant="light" >
								<div @click="openModal(null)" class="dropdown-item" >Crear Cliente</div>
								<div @click="exportData()" class="dropdown-item" >Exportar listado</div>
							</b-dropdown>

							<!-- <button class="btn btn-sm btn-outline-secondary" @click="openModal(null)">Crear cliente</button> -->
						</div>
					</div>

						
					<div class="filters-box">
						<div class="filter">
							<label>BUSCAR</label>
							<input 
								type="text" 
								class="form-control" 
								placeholder="Buscar" 
								v-model="filters.search" 
								@keyup.enter="updateFilters($event)">
						</div>
						<!-- <div class="btn btn-light " @click="exportData()">Exportar</div> -->
					</div>
				
					<table class="table table-clickeable">
						<tr class="table-head">
							<td>Cliente</td>
							<td>Email</td>
							<td>Teléfono</td>
						</tr>
						
						<router-link tag="tr" :to="`/clients/${item.id}`" v-for="item of list" :key="item.id" >
							<td >
								<div class="tc">
									<span class="text-primary">{{item.name}}</span>
									<span >{{item.business_name}}</span>
								</div>
							</td>
							<td>{{item.email}}</td>
							<td>
								<span v-if="item.phone">
									{{item.phone.national}}
								</span>
							</td>
						</router-link>
						
					</table>

					<div class="alert alert-info text-center" v-if="list.length==0" >No se han encontrado vehículos</div>
					
					<vue-ads-pagination v-if="pagination"
						:total-items="pagination.total"
						:max-visible-pages="2"
						:items-per-page="pagination.length"
						:page="pagination.page-1"
						@page-change="pageChange"					
					></vue-ads-pagination>
				</div>
			</div>
		</div>
	</div>

	<ClientModal ref="clientModal" @updated="load()"></ClientModal>

</div>
</template>

<script>
import gql from 'graphql-tag'
import listMixins from '@/mixins/listMixins'
import { buildExportUrl } from '@/lib/exportsUrl'

import Navbar from '@/components/Navbar'
import Loader from '@/components/Loader'

import ClientModal from '@/views/clients/ClientModal'

export default {
	name: 'cars',
	components:{
		Navbar,
		Loader,
		ClientModal
	},
	mixins:[listMixins],
	data () {
		return {
			list:[],
			loading: true,
		}
	},
	beforeMount(){
		this.filters = this.getValidUrlParams();
		this.load();
	},
	methods:{
		exportData(){
			window.open(buildExportUrl('export-clients', this.$route.query), '_blank');
		},
		load(){
			this.$apollo.query({
				query: gql`query ($first: Int!, $page: Int, $search: String ) {
					clients(first: $first, page: $page, search: $search) {
						paginatorInfo {
							count
							currentPage
							total
						}
						data {
							id
							name
							business_name
							users{
								name
							}
							email
							phone{
								national
							}
							status							
						}
					}
				}`,
				variables: {
					page: this.pagination.page,
					first: this.pagination.length,
					search: this.filters.search,
				},
				fetchPolicy: 'no-cache',
			})
			.then((data) => {
				this.list = data.data.clients.data;
				this.pagination.total = data.data.clients.paginatorInfo.total;
				this.loading = false
			});
		},
		openModal(id){
			this.$refs.clientModal.open(id)
		}

	}
}


</script>

<style>

</style>
